export default __webpack_public_path__ + "static/media/(54).c5208c07.jpg";